import {
  UPDATE_FUND_COUNT,
  LOAD_FUND_PROFILE,
  LOAD_RELATED_FUNDS,
  SET_PROFILE_CATEGORY,
  RESET_PAGE,
  REMOVE_TICKER,
  CLEAR_TICKERS,
  LOADING,
  PERF_LOADING, ERROR,
  REMOVE_RELATED_FUND,
  LOAD_PERFORMANCE,
  LOAD_SEARCH_RESULTS,
  LOADING_SEARCH_RESULTS,
  CLEAR_SEARCH_RESULTS,
  FETCH_STRUCTURE_LOADING,
  FETCH_STRUCTURE_ERROR,
  SET_FUND_DETAILS_STRUCTURE,
  SET_FUND_DETAILS_PERFORMANCE,
  SET_FUND_DETAILS_RUN_ID,
  ADD_PENDING_DATASPAN_REQUESTS,
  REMOVE_PENDING_DATASPAN_REQUESTS,
} from '../actions'

// fundData reducer
const fundData = (state, action) => {
  if (state === undefined) {
    return {}
  }
  switch (action.type) {
    case LOAD_FUND_PROFILE:
      // assign fundCategoryTier1 field for benchmarks and append "index" to name
      let funds = action.payload.data.map(fund => {
        if (fund.type === 'BMK') {
          fund.fundCategoryTier1 = 'Benchmarks'
        }
        return fund
      })
      // filter out to just equity , alternatives, and benchmarks
      funds = funds.filter(function (value) {
        return value.fundCategoryTier1 && (value.fundCategoryTier1.includes('Equity') || value.fundCategoryTier1 === 'Thematic' || value.fundCategoryTier1 === 'Fixed Income' || value.fundCategoryTier1 === 'Benchmarks')
      })
      // append cat2 to equity
      funds = funds.map(fund => {
        if (fund.fundCategoryTier1.includes('Equity')) {
          fund.fundCategoryTier1 = `${fund.fundCategoryTier1} - ${fund.fundCategoryTier2}`
        }
        if (fund.fundCategoryTier1.includes('Fixed Income')) {
          fund.fundCategoryTier1 = `${fund.fundCategoryTier1} - ${fund.fundCategoryTier2}`
        }
        return fund
      })
      return Object.assign({}, state, {
        tickers: funds
      })
    case LOAD_RELATED_FUNDS:
      return Object.assign({}, state, {
        relatedFunds: action.payload
      })
    case REMOVE_RELATED_FUND:
      const curFunds = Object.assign([], state.relatedFunds)
      const newFunds = curFunds.filter(fund => fund.externalID !== action.payload.externalID)
      return Object.assign({}, state, {
        relatedFunds: newFunds
      })

    case SET_FUND_DETAILS_STRUCTURE:
      const fundDetails = fundDetailsEnrichment(action.payload)
      console.log('fundDetails', fundDetails)
      return Object.assign({}, state, {
        fcBottomSelected: 'hide',
        fcHideOptions: 'hide',
        fcShowData: 'show',
        btnReset: 'show',
        btnSubmit: 'hide',
        data: fundDetails,
        // runId: action.payload.data.runId,
        // runEmail: action.payload.data.email
      })
    case SET_FUND_DETAILS_PERFORMANCE:
      const fundDetailsPerformance = fundDetailsEnrichment(action.payload);
      return {
        ...state,
        data: state.data.map((item, index) => ({
          ...item,
          stdPerformance: fundDetailsPerformance[index].stdPerformance,
          stdPerformanceMonthly: fundDetailsPerformance[index].stdPerformanceMonthly,
          levels: fundDetailsPerformance[index].levels,
          calYearPerformance: fundDetailsPerformance[index].calYearPerformance,
          stdRisk: fundDetailsPerformance[index].stdRisk,
          sharpeRatio: fundDetailsPerformance[index].sharpeRatio,
          upCapture: fundDetailsPerformance[index].upCapture,
          downCapture: fundDetailsPerformance[index].downCapture,
          alpha: fundDetailsPerformance[index].alpha,
          beta: fundDetailsPerformance[index].beta,
          correlations: fundDetailsPerformance[index].correlations,
          levelsDaily: fundDetailsPerformance[index].levelsDaily,
          stdPerformanceDaily: fundDetailsPerformance[index].stdPerformanceDaily,
          drawDownPerformance: fundDetailsPerformance[index].drawDownPerformance,
          drawDownDetails: fundDetailsPerformance[index].drawDownDetails,
          ttmDivYields: fundDetailsPerformance[index].ttmDivYields,
        })),
      }
    case SET_FUND_DETAILS_RUN_ID:
      return Object.assign({}, state, {
        runId: action.payload.runId,
        runEmail: action.payload.runEmail
      })

    case LOAD_PERFORMANCE:
      return Object.assign({}, state, {
        perfData: action.payload
      })
    case SET_PROFILE_CATEGORY:
      const fundListing = state.tickers.filter(function (value) {
        return value.fundCategoryTier1 === action.payload
      })
      return Object.assign({}, state, {
        catFunds: fundListing
      })
    case RESET_PAGE:
      return Object.assign({}, state, {
        btnReset: 'hide',
        btnSubmit: 'show',
        fcHideOptions: 'show',
        fcShowData: 'hide'
      })
    case REMOVE_TICKER:
      const data = [...state.data]
      const dataUp = data.filter(fund => fund.externalID !== action.payload)
      let fcShowData = 'hide'
      if (dataUp.length > 0) {
        fcShowData = 'show'
      }
      return Object.assign({}, state, {
        data: dataUp,
        fcShowData: fcShowData
      })
    case CLEAR_TICKERS:
      return Object.assign({}, state, {
        data: [],
        fcShowData: 'hide',
        runId: null,
        runEmail: null
      })
    case LOADING:
      return Object.assign({}, state, {
        loading: action.payload
      })
    case FETCH_STRUCTURE_LOADING:
      return Object.assign({}, state, {
        loadingStructure: action.payload
      })
    case FETCH_STRUCTURE_ERROR:
      return Object.assign({}, state, {
        loadingStructure: action.payload
      })
    case ADD_PENDING_DATASPAN_REQUESTS:
      return Object.assign({}, state, {
        pendingDataspanRequests: [...state.pendingDataspanRequests, action.payload]
      })
    case REMOVE_PENDING_DATASPAN_REQUESTS:
      return Object.assign({}, state, {
        pendingDataspanRequests: state.pendingDataspanRequests.filter(token => token !== action.payload)
      })
    case PERF_LOADING:
      return Object.assign({}, state, {
        loadingPerformance: action.payload
      })
    case ERROR:
      return Object.assign({}, state, {
        error: action.payload
      })
    case LOAD_SEARCH_RESULTS:
      return Object.assign({}, state, {
        searchResults: action.payload
      })
    case LOADING_SEARCH_RESULTS:
      return Object.assign({}, state, {
        loadingSearchResults: action.payload
      })
    case CLEAR_SEARCH_RESULTS:
      return Object.assign({}, state, {
        searchResults: null
      })
    case UPDATE_FUND_COUNT:
      return Object.assign({}, state, {
        fundCount: action.payload
      })
    default:
      return state
  }
}

function fundDetailsEnrichment(actionsPayload) {
  const fundDetails = actionsPayload.data.data.map(fund => {
    if (fund.type === 'BMK') {
      fund.fundCategoryTier1 = 'Benchmarks'
    }
    if (fund.type !== 'WTETF' && fund.type !== 'BMK') {
      fund.fundCategoryTier1 = fund.type
    }
    fund.esgOverallRiskMetrics = JSON.parse(JSON.stringify(fund.esgOverallMetrics))

    if (fund.countryExposuresSOESummary !== null) {
      let sectorSOEData = fund.sectorExposuresSOE[fund.sectorExposuresSOE.length - 1]
      let sectorNonSOEData = fund.sectorExposuresNonSOE[fund.sectorExposuresNonSOE.length - 1]
      let sectorSOEVals = sectorSOEData.values.map(x => x)
      let sectorNonSOEVals = sectorNonSOEData.values.map(x => x)
      var sectorSOESubTotalVals = []
      for (var i = 0; i < sectorSOEVals.length; i++) {
        sectorSOESubTotalVals.push(sectorSOEVals[i] + sectorNonSOEVals[i])
      }
      fund.sectorSOESubTotals = [JSON.parse(JSON.stringify(sectorSOEData))]
      fund.sectorSOESubTotals[0].values = sectorSOESubTotalVals
      // country subtotals
      let countrySOEData = fund.countryExposuresSOE[fund.countryExposuresSOE.length - 1]
      let countryNonSOEData = fund.countryExposuresNonSOE[fund.countryExposuresNonSOE.length - 1]
      let countrySOEVals = countrySOEData.values.map(x => x)
      let countryNonSOEVals = countryNonSOEData.values.map(x => x)
      var countrySOESubTotalVals = []
      for (let j = 0; j < countrySOEVals.length; j++) {
        countrySOESubTotalVals.push(countrySOEVals[j] + countryNonSOEVals[j])
      }
      fund.countrySOESubTotals = [JSON.parse(JSON.stringify(countrySOEData))]
      fund.countrySOESubTotals[0].values = countrySOESubTotalVals
    }

    // Set up the Morningstar URL
    var mainDomain = ''
    if (fund.type === 'ETF') {
      mainDomain = 'etfs'
    } else if (fund.type === 'MF') {
      mainDomain = 'funds'
    }
    let subDomain = ''
    switch (fund.exchangeCode) {
      case 'NASDAQ':
        subDomain = 'xnas'
        break
      case 'Arca':
      case 'NYSE':
        subDomain = 'arcx'
        break
      case 'BATS ECN - RDFD':
        subDomain = 'bats'
        break
      default:
        subDomain = 'xnas'
    }
    fund.msUrl = `https://www.morningstar.com/${mainDomain}/${subDomain}/${fund.ticker}/performance`

    return fund
  })

  return fundDetails
}


export default fundData
